<template>
  <el-tabs v-model="checkValue"  type="card" closable @tab-remove="removeTab" style="height: 100%;">
    <el-tab-pane
      v-for="item in tabList"
      :key="item.name"
      :label="item.title"
      :name="item.name"
    >
      <iframe :src="item.name" class="aside" width="100%" :height="iframeH" frameborder="0" scrolling="auto" allowtransparency="true" ></iframe>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: {
    tabList:{
      //菜单内容
      type: Array
    },
    tabValue:{
      type: String,
      default: ''
    },
    tabRemoveEventName:{
      type:String
    }
  },
  data () {
    return {
      checkValue:'',
      iframeH:"400px"
    }
  },
  methods:{
    removeTab(targetName) {
      this.$emit(this.tabRemoveEventName,targetName)
    }
  },
  watch: {
    //监听prop传的value，如果父级有变化了，将子组件的myValue也跟着变，达到父变子变的效果
    tabValue(newVal) {
      const deviceHeight = document.documentElement.clientHeight;
      this.checkValue = newVal;
      this.iframeH = (Number(deviceHeight)-120) + 'px';
    }
  }
}
</script>
<style scoped>
  .Main_iframe{
    width: 100%;
    margin: 0;padding: 0;
    border: none;
  }
  .aside{
    overflow-x: hidden;overflow-y: auto
  }
  .aside::-webkit-scrollbar {/*滚动条整体样式*/
    width: 7px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .aside::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #535353;

  }
  .aside::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 7px;
    background: #EDEDED;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainTab/index.vue